<template lang="pug">
    .category-posts.teaser-list.container(v-if="section.categories")

        .horizontal(v-if="orientation === 'horizontal'")
            loading(:active="loading || fetching" :is-full-page="false" :height="40" :width="40" color="#e30018")
            .teasers(v-if="loading")
                .teaser.skeleton(v-for="teaser in teasers" :style="style")
                    .image
                    .text
            .paginated-teasers(v-else)
                .teasers
                    .teaser(v-for="teaser in teasers" :style="style")
                        Teaser(:teaser="teaser" :origin="section.id" :show-date="showDate" display="card" )
                    // .teaser.skeleton(:style="style")
                    //     .image
                    //     .text
                Pagination(
                    v-if="pageInfo && pageInfo.lastPage > 1"
                    :last-page="pageInfo.lastPage"
                    :current-page="pageInfo.currentPage"
                    nav-class="pagination is-rounded is-centered"
                    @change="load"
                )
                    span.icon(slot="prev")
                        font-awesome-icon(icon="arrow-left")
                    span.icon(slot="next")
                        font-awesome-icon(icon="arrow-right")

        .vertical(v-else)
            .column.is-offset-1.is-10
                loading(:active="loading || fetching" :is-full-page="false" :height="40" :width="40" color="#e30018")
                .teasers(v-if="loading")
                    .teaser.skeleton(v-for="teaser in teasers")
                        .image
                        .text
                .paginated-teasers(v-else)
                    .teasers
                        .teaser(v-for="teaser in teasers")
                            Teaser(:teaser="teaser" :origin="section.id" display="row" :show-date="showDate" :show-topic="!!section.categories.length")
                        // .teaser.skeleton
                        //     .image
                        //     .text
                Pagination(
                    v-if="pageInfo && pageInfo.lastPage > 1"
                    :last-page="pageInfo.lastPage"
                    :current-page="pageInfo.currentPage"
                    nav-class="pagination is-rounded"
                    @change="load"
                )
                    span.icon(slot="prev")
                        font-awesome-icon(icon="arrow-left")
                    span.icon(slot="next")
                        font-awesome-icon(icon="arrow-right")

</template>

<script>

import _ from 'lodash'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import store from '@/store'

import Loading from 'vue-loading-overlay'
import Teaser from './Teaser'

import Pagination from '@/components/Pagination'

export default {
    name: 'CategoryPosts',
    props: {
        section: {
            type: Object,
            required: true,
        },
        perPage: {
            type: Number,
            default: null,
        },
        orientation: {
            type: String,
            default: 'vertical',
        }
    },
    data: () => {
        return {
            fetching: false,
            defaultPerPage: 10,
        }
    },
    components: {
        Loading,
        Teaser,
        Pagination,
    },
    computed: {
        s() {
            return _.findIndex(this.sections, { id: this.section.id })
        },
        loading() {
            return _.get(this.section, 'teasers.loading', true)
        },
        itemsPerPage() {
            let perPage = this.perPage || this.defaultPerPage;

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'per_page')
                if (setting && setting.value !== undefined) perPage = setting.value
            }

            return perPage
        },
        teasers() {
            let teasers = []
            if (this.loading) {
                if (this.orientation === 'horizontal') teasers = new Array(this.itemsPerPage)
                else teasers = new Array(3)
            } else {
                teasers = _.get(this.section, 'teasers.pagination.items')
            }
            return teasers
        },

        sort() {
            const settings = _.get(this.section, 'settings') || []
            const sortOrder = settings.find(setting => setting.key === 'sort_order') || {order: 'desc', grouped: 'date'}
            switch (sortOrder.value) {
                case 'date_desc':
                    return {order: 'desc', grouped: 'date'}
                    break
                case 'date_asc':
                    return {order: 'asc', grouped: 'date'}
                    break
                case 'title_desc':
                    return {order: 'desc', grouped: 'title'}
                    break
                case 'title_asc':
                    return {order: 'asc', grouped: 'title'}
                    break
                default:
                    return {order: 'desc', grouped: 'date'}
                    break
            }
        },

        showDate() {
            const settings = _.get(this.section, 'settings') || []
            const showDate = settings.find(setting => setting.key === 'show_date') || false

            if(showDate.value === "true") {
               return true
            } else {
                return false
            }
        },

        filters() {
            return _.get(this.section, 'teasers.pagination.filters')
        },
        pageInfo() {
            return _.get(this.section, 'teasers.pagination.pageInfo')
        },
        style() {
            return {
                width: `calc(${100 / this.itemsPerPage}% - 20px)`
            }
        },
        ...mapGetters('currentPage', {
            sections: 'sections',
            cms: 'CMS',
            reference: 'reference'
        })
    },
    methods: {
        load(page = 1) {
            this.fetching = true;

            let pagination = _.get(this.section, 'teasers.pagination')

            if (! pagination) {

                const cms = store.getters.CMS.id

                const categoryIDs = this.section.categories.map(category => category.id);
                const tagIDs = this.section.tags.map(tag => tag.id)

                let filters = [
                    // {
                    //     key: 'categories',
                    //     in: categoryIDs
                    // },
                    // {
                    //     key: 'tags',
                    //     in: tagIDs
                    // },
                    {
                        key: 'section-selection',
                        match: this.section.id
                    },
                ]

                pagination = {
                    filters,
                    variables: {
                        order: this.sort.grouped,
                        direction: this.sort.order
                    },
                    pageInfo: {
                        currentPage: 1,
                        lastPage: 1,
                        total: 0,
                        perPage: this.itemsPerPage
                    },
                }
            }

            pagination.pageInfo.currentPage = page
            this.fetchTeasers(pagination)
                .then(({ items, pageInfo }) => {
                    let filters = _.cloneDeep(pagination.filters);
                    let variables = _.cloneDeep(pagination.variables);
                    const teasers = {
                        loading: false,
                        pagination: { filters, items, pageInfo, variables }
                    };
                    this.insertTeasers({ s: this.s, teasers });
                })
                .finally(() => (this.fetching = false));
        },
        ...mapMutations('currentPage', {
            updateTeasersLoading: 'updateCategoryPostTeasersLoading',
            insertTeasers: 'insertTeasers',
        }),
        ...mapActions('currentPage', {
            fetchTeasers: 'fetchCategoryPostTeasers',
        }),
    },
    mounted() {
        this.load();
    }
}
</script>

<style lang="scss" scoped></style>
